// extracted by mini-css-extract-plugin
module.exports = {"boxImage":"BoxImage_boxImage__dHAOl"};